import styled from 'styled-components';

export const TPContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin: 2rem 0;
    @media ${({ theme }) => theme.device.tabletL} {
     //flex-direction: column;
     //  margin: 0rem 0 1rem 0rem;
     //   justify-content: start;
        
    }
`

export const PerPageGroup = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: 2px solid #F5FBFF;
    border-radius: 8px;
    padding: 0.25rem;
    font-size: 0.9rem;
      @media ${({ theme }) => theme.device.tabletL} {
       //font-size: 0.7rem;
       //margin-bottom: 8px;
       //width:100%;
       //    justify-content: start;
        
    }
`

export const PerPageLabel = styled.label`
    display: flex;
    margin: 0;
    padding: 0;
     font-size: 0.85rem;
    color: ${({ theme }) => theme.colors.textBody};
    @media ${({ theme }) => theme.device.tabletL} {
        font-size: 0.75rem;
    }

`
export const LabelDensityAndColumns = styled.label`
    display: flex;
    margin: 0;
    padding: 0;
    color: ${({ theme }) => theme.colors.textBody};
    font-size: 0.85rem;
    margin-left: 5px;
    cursor: pointer;
      @media ${({ theme }) => theme.device.tabletL} {
        font-size: 0.75rem;
    }
`

export const PerPageSelect = styled.select`
 background: white;
    cursor: pointer;
    border: none;
    outline: none;
    width: fit-content;
    text-align: right;
    font-size: 0.85rem;
    color: ${({ theme }) => theme.colors.textBody};
      @media ${({ theme }) => theme.device.tabletL} {
        font-size: 0.75rem;
    }
`